export const providerProducts = {
  tables: {
    cloth_id: "cloths",
    sewing_accessory_id: "sewing_accessories",
    stationery_id: "stationery",
    expendable_material_id: "expendable_materials",
    promotional_product_id: "promotional_products",
    package_id: "packages",
  },
  sublists: {
    cloth: "cloths",
    sewing_accessory: "sewing_accessories",
    stationery: "stationery",
    expendable_material: "expendable_materials",
    promotional_product: "promotional_products",
    package: "packages",
  },
  entities: {
    cloths: "Ткани",
    sewing_accessories: "Фурнитура",
    stationery: "Канцелярия",
    expendable_materials: "Расходники",
    promotional_products: "Рекламная продукция",
    packages: "Упаковка",
  },
  subtypes: {
    sewing_accessory_id: "фурнитура",
    cloth_id: "ткань",
    stationery_id: "канцелярия",
    expendable_material_id: "расходник",
    promotional_product_id: "рекламная продукция",
    package_id: "упаковка",
  },
};



// WEBPACK FOOTER //
// ./src/business/constants/providerProducts.js